export const HIGHLIGHT_NOTE_CLASS_NAME = 'highlight'
